import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '@entities/auth/model/useAuthStore';
import decodeJwt from '@shared/lib/decodeJwt'; // 라이브러리가 없다면 아래 직접 구현 함수 참고

const AdminProtectedRoute = ({ children }) => {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  // 1. 토큰이 아예 없으면 로그인 페이지로
  if (!token) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  try {
    // 2. Zustand의 user 정보가 있다면 먼저 확인
    let isAdmin = user?.admin === 1;

    // 3. 만약 user 정보가 없다면(새로고침 직후 등), 토큰을 직접 디코딩해서 확인
    if (!isAdmin && token) {
      const decoded = decodeJwt(token);
      // 토큰 내부의 필드명(admin)은 백엔드 설정에 따라 다를 수 있습니다 (예: role, isAdmin 등)
      if (decoded.admin === 1) {
        isAdmin = true;
      }
    }

    // 4. 최종 확인 결과 관리자가 아니라면 튕겨냄
    if (!isAdmin) {
      console.warn('관리자 권한이 없는 토큰입니다.');
      return <Navigate to="/admin/login" replace />;
    }
  } catch (error) {
    console.error('토큰 디코딩 중 오류 발생:', error);
    return <Navigate to="/admin/login" replace />;
  }

  // 5. 관리자임이 확인되면 자식 컴포넌트(페이지) 렌더링
  return children;
};

export default AdminProtectedRoute;
